import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { LandingPage } from './pages/LandingPage';
import { OnboardingForm } from './pages/OnboardingForm';
import { StatusPage } from './pages/StatusPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { CoiRenewalPage } from './pages/CoiRenewalPage';
import { UpdateBanner } from './components/UpdateBanner';

/**
 * MUL-3919: read `paymentTermsNegotiable` from sessionStorage. The value is
 * written by LandingPage.handleVerify after a successful /verify/check, and
 * mirrors what the server returned (CW contact lookup against the verified
 * email — §2 of the contract). Defaulting to `false` keeps a stale tab from
 * accidentally presenting a step whose submit the server will silently drop.
 */
function readNegotiable(): boolean {
  try {
    return sessionStorage.getItem('hts_payment_terms_negotiable') === 'true';
  } catch {
    return false;
  }
}

function VerifiedRoute() {
  const verifiedEmail = sessionStorage.getItem('hts_verified_email');
  if (!verifiedEmail) return <Navigate to="/" replace />;
  return <OnboardingForm verifiedEmail={verifiedEmail} paymentTermsNegotiable={readNegotiable()} />;
}

export function App() {
  return (
    <BrowserRouter>
      <UpdateBanner />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/apply" element={<VerifiedRoute />} />
        <Route path="/status/:accessToken" element={<StatusPage />} />
        <Route path="/coi/:token" element={<CoiRenewalPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
      </Routes>
    </BrowserRouter>
  );
}